import React from "react";
import { exact, number, string } from "prop-types";
import { percentageLevels } from "utils/indicator/indicatorSettings";
import styles from "./MunicipalityBuildingLoadingRow.module.styl";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";
import { chartOptions, smallChartWidth } from "utils/chart/chartOptions";

export default function MunicipalityBuildingLoadingRow({
    regionId,
    municipalityId,
    sportObjectLoading,
}) {
    const indicatorStyle = percentageLevels.indicatorColor(sportObjectLoading.loading);
    const options = chartOptions(indicatorStyle);
    const series = [sportObjectLoading.loading];

    return (
        <div className={styles.row}>
            <Link
                to={`/loading/region/${regionId}/municipality/${municipalityId}/building/${sportObjectLoading.id}`}
                className={styles.buildingName}
            >
                {sportObjectLoading.name}
            </Link>
            <div className={styles.chart}>
                <Chart options={options} series={series} type="radialBar" width={smallChartWidth} />
            </div>
        </div>
    );
}

MunicipalityBuildingLoadingRow.propTypes = {
    regionId: number.isRequired,
    municipalityId: number.isRequired,
    sportObjectLoading: exact({
        id: number.isRequired,
        name: string.isRequired,
        loading: number.isRequired,
    }),
};
